import { Component, inject } from '@angular/core';
import { RouterLink, RouterOutlet } from '@angular/router';
import { Observable } from 'rxjs';
import { environment } from '../environments/environment';
import { Auth, UserProfile } from '@angular/fire/auth';
import { CommonModule } from '@angular/common';
import { addDoc, collection, collectionData, DocumentReference, Firestore } from '@angular/fire/firestore';
import { NgbToastModule } from '@ng-bootstrap/ng-bootstrap';
import { UiControllerService } from './services/ui-controller.service';

@Component({
    selector: 'app-root',
    imports: [RouterOutlet, CommonModule, NgbToastModule],
    templateUrl: './app.component.html',
    styleUrl: './app.component.scss'
})
export class AppComponent {

  public _uiController = inject(UiControllerService);

  public env = environment;

  constructor(){
  }

  ngOnInit() {
  }

}
